import script from "./headerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./headerComponent.vue?vue&type=script&setup=true&lang=js"

import "./headerComponent.vue?vue&type=style&index=0&id=36ae2168&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ae2168"]])

export default __exports__